export const GET_CHANNELS_SUCCESS = 'GET_CHANNELS_SUCCESS'
export const UPDATE_CHANNEL_SUCCESS = 'UPDATE_CHANNEL_SUCCESS'
export const ADD_CHANNEL_SUCCESS = 'ADD_CHANNEL_SUCCESS'
export const DELETE_CHANNEL_SUCCESS = 'DELETE_CHANNEL_SUCCESS'
export const SET_FETCHING_CHANNELS = 'SET_FETCHING_CHANNELS'
